var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("filter-component", {
        attrs: { tags: this.tags, checked: this.checked },
        on: { tags: _vm.updateCheckedList },
      }),
      _vm._v(" "),
      _c("portfolio-list-component", {
        attrs: { items: this.items, initial: this.initialArray },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "portfolio__footer" },
        [
          _c("load-more-button-component", {
            attrs: { disabled: this.isLoadMoreButtonDisabled },
            on: { load: _vm.loadMoreItems },
          }),
          _vm._v(" "),
          _c("collapse-button-component", {
            attrs: { state: this.isCollapseButtonDisabled },
            on: { collapse: _vm.collapsePortfolioList },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }